/**
 * Ảnh chụp khách ở web quầy (L5-21 / L5-22): thu nhỏ ở máy trước khi gửi + đổi mọi lỗi thành MỘT câu tiếng Việt nói rõ nguyên nhân và cách khắc phục.
 * Tách khỏi `HoSoBuoi.tsx` để test được và để dùng lại đường mở ảnh có dự phòng `<img>` của `anh-cua-hang.ts` (Safari < 15 không có
 * `createImageBitmap`; docs/soat/loi-luu-anh-khach.md, lỗi 5).
 */
import { LoiAnh, moAnh } from './anh-cua-hang.ts'
import { ApiFailure } from './api.ts'
import { H } from './text/ho-so.ts'
import { T } from './text/vi.ts'

/** Cạnh dài tối đa của ảnh gửi lên: ảnh tablet 12–48 MP thu về 1.600px JPEG (máy chủ vẫn làm sạch EXIF / GPS và mã hoá lại). */
export const CANH_DAI_PX = 1600

/**
 * Thu nhỏ ảnh ở máy → JPEG base64 (không tiền tố `data:`). Mở ảnh bằng `moAnh` (createImageBitmap, không có thì `<img>`).
 * Ném `LoiAnh('khong-doc')` khi định dạng máy không mở được (vd. HEIC ở trình duyệt không giải mã), `LoiAnh('khong-nen')` khi canvas không vẽ / mã hoá được.
 */
export async function thuNho(tep: File): Promise<string> {
  const mo = await moAnh(tep)
  try {
    if (!(mo.rong > 0) || !(mo.cao > 0)) throw new LoiAnh('khong-doc')
    const tiLe = Math.min(1, CANH_DAI_PX / Math.max(mo.rong, mo.cao))
    const canvas = document.createElement('canvas')
    canvas.width = Math.max(1, Math.round(mo.rong * tiLe))
    canvas.height = Math.max(1, Math.round(mo.cao * tiLe))
    const ctx = canvas.getContext('2d')
    if (ctx === null) throw new LoiAnh('khong-nen')
    ctx.drawImage(mo.nguon, 0, 0, canvas.width, canvas.height)
    const dataUrl = canvas.toDataURL('image/jpeg', 0.85)
    // Canvas quá lớn / hết bộ nhớ thì `toDataURL` trả "data:," (rỗng) chứ không ném lỗi.
    if (!dataUrl.startsWith('data:image/jpeg')) throw new LoiAnh('khong-nen')
    return dataUrl.slice(dataUrl.indexOf(',') + 1)
  } finally {
    mo.dong()
  }
}

/** 409 `CAU_HOI_DOI` (V3): cách xử lý ảnh của máy chủ đổi giữa lúc hiện câu hỏi và lúc bấm "Khách đồng ý" → phải tải lại câu hỏi. */
export function loiDoiCauHoi(e: unknown): boolean {
  return e instanceof ApiFailure && e.code === 'CAU_HOI_DOI'
}

/** Lỗi khi bấm "Khách đồng ý": hai mã 409 (câu hỏi đổi · web cần cập nhật) và mọi lỗi máy chủ khác dùng nguyên câu của máy chủ; lạ → câu chung. */
export function cauLoiDongYAnh(e: unknown): string {
  return e instanceof ApiFailure && e.messageVi.trim() !== '' ? e.messageVi : T.serverFailed
}

/**
 * Lỗi của luồng chụp / lưu / xem ảnh khách → MỘT câu hiện NGAY TRONG khối ảnh. Lỗi ĐỊNH DẠNG (ảnh không mở được) tách khỏi lỗi MẠNG:
 * mỗi loại một câu và nói thợ phải làm gì. Câu tiếng Việt của máy chủ (chưa đồng ý, kho ảnh không ghi được…) dùng nguyên văn.
 */
export function cauLoiAnhKhach(e: unknown): string {
  if (e instanceof LoiAnh) return e.ma === 'khong-nen' ? H.khongNenDuocAnh : H.khongDocDuocAnh
  if (e instanceof ApiFailure) {
    if (e.code === 'OFFLINE') {
      // POST hết giờ: máy chủ CÓ THỂ đã ghi — không bảo bấm lại như chắc chắn chưa lưu.
      return e.hetGio ? H.loiMangHetGioAnh : H.loiMangAnh
    }
    if (e.status === 413) return H.anhQuaNang
    if (e.messageVi.trim() !== '') return e.messageVi
  }
  return T.serverFailed
}
